"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[533],{

/***/ 6533:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ VideoSection; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _components_container__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2606);
/* harmony import */ var _lib_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(608);



function VideoSection(param) {
    let { data: { video  }  } = param;
    if (!video) return null;
    let __html = video.rawData.html;
    // append vimeo start-time-fragment to iframe src
    if (video.rawData.provider_name === "Vimeo") {
        const vimeoStartAt = video.url.match(/(t=[0-9]*s)/);
        if (vimeoStartAt) {
            __html = __html.replace(/src="(.*?)"/, 'src="$1#'.concat(vimeoStartAt[0], '"'));
        }
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_container__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        size: _lib_types__WEBPACK_IMPORTED_MODULE_2__/* .ContainerSize.wide */ .B.wide,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "lg:grid grid-cols-12 gap-1.5 md:gap-6",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "col-start-3 col-span-8",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "aspect-w-16 aspect-h-9 rounded-xl md:rounded-3xl overflow-hidden",
                    dangerouslySetInnerHTML: {
                        __html
                    }
                })
            })
        })
    });
}


/***/ })

}]);